module.exports = __webpack_public_path__ + "media/images/ticv-5ace9e36ea7d5d75dce6eae1e8d12083.png";